import { render, staticRenderFns } from "./sunflowerResult.vue?vue&type=template&id=58a5dd1c&scoped=true"
import script from "./sunflowerResult.vue?vue&type=script&lang=js"
export * from "./sunflowerResult.vue?vue&type=script&lang=js"
import style0 from "./sunflowerResult.vue?vue&type=style&index=0&id=58a5dd1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5dd1c",
  null
  
)

export default component.exports